import { useEffect } from 'react'
import api from '../../api'
import { getLocalStorage, isSuccess, showError } from '../../utils/helper'

const PermissionChecker = () => {
  useEffect(() => {
    if (getLocalStorage('access_token')) {
      const handleCheckP = () => {
        api
          .postCheckPermission({
            permissions: JSON.parse(getLocalStorage('permissions') || '[]'),
          })
          .then((response: any) => {
            if (isSuccess(response)) {

              const updatedPermissions = response?.data?.data
              if (updatedPermissions && Array.isArray(updatedPermissions) && updatedPermissions?.length) {
                localStorage.setItem('permissions', JSON.stringify(updatedPermissions))
                window.location.reload()
              }
            }
          })
          .catch((error: any) => {
            showError(error)
          })
      }

      handleCheckP()
    }
  }, [])

  return null
}

export default PermissionChecker
